// extracted by mini-css-extract-plugin
module.exports = {"wrapPanigation":"styles_wrapPanigation__exxUV"};